import React from "react";
import { HashLink as Link } from 'react-router-hash-link';
import { Button } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import "../Certificacion/Curso.css";

interface Props {
    move : any
    tipo:any
    id:any
    data: any
}

export default function CCTMovimientoUpdate(props:Props) {
    const {userStore: {user}} = useStore();
    const {CCTMovimientoReporteStore, modalStore} = useStore();
    const {updateCCTMovimiento} = CCTMovimientoReporteStore;
    if(props.tipo == "AN"){
        return(
            <div>
                <h4>¿Seguro que quieres anular este movimiento?</h4>
                <Button color="blue" variant="contained" onClick={() => {updateCCTMovimiento(props.id, "AN", props.data)
                    modalStore.closeModal()}}>si</Button>
                <Button variant="contained" onClick={() => {modalStore.closeModal()}}>No</Button>
            </div>
        )
    }else{
        return(
            <div>
                <h4>¿Seguro que quieres activar este movimiento?</h4>
                <Button color="blue" variant="contained" onClick={() => {updateCCTMovimiento(props.id, "AC", props.data)
                    modalStore.closeModal()}}>si</Button>
                <Button variant="contained" onClick={() => {modalStore.closeModal()}}>No</Button>
            </div>
        )
    }
}